import { render } from "./Autosaisine.vue?vue&type=template&id=365fe8c6"
import script from "./Autosaisine.vue?vue&type=script&lang=js"
export * from "./Autosaisine.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__